import axios from "axios";

export function makeApiClient(baseUrl, options) {
  return axios.create({
    baseURL: baseUrl,
    withCredentials: true,
    timeout: 10000,
    ...options,
  });
}
